module.exports = __webpack_public_path__ + "img/Dantam Hair 09B.410df381.jpg";